import slideshow from './grouped-tiles-slideshow';

slideshow('#home-tiles-happenings');